import { Injectable, inject } from "@angular/core";
import remove from "lodash/remove";
import { BehaviorSubject, Observable } from "rxjs";
import { WebinstallningarService } from "~app/common/services/webinstallningar/webinstallningar.service";
import { ISavedVKSearchFilters, IVKNamedSearchFilter } from "../../models/kontrakt-search-filter-model";
import { KONTRAKT_FILTER_KEY } from "./kontrakt-token-keys";

@Injectable({
    providedIn: "root"
})

export class KontraktSearchMinaFilterService {
    private readonly webinstallningarService = inject(WebinstallningarService);

    get minaSparadeFilter(): Observable<IVKNamedSearchFilter[]> {
        return this.minaSokfilter$.asObservable();
    }

    private readonly WIK;
    private readonly maxSavedFilters = 10;
    private readonly minaSokfilter$: BehaviorSubject<IVKNamedSearchFilter[]> = new BehaviorSubject<IVKNamedSearchFilter[]>([]);

    constructor() {
        const key = inject(KONTRAKT_FILTER_KEY);

        this.WIK = key;
        this.getInstallningar();
    }

    getInstallningar() {
        this.webinstallningarService
            .getAsync(this.WIK)
            .then((value: ISavedVKSearchFilters) => {
                if (value && value.minaFilter) {
                    this.minaSokfilter$.next(value.minaFilter);
                }
            });
    }

    nameIsUnique(filter: IVKNamedSearchFilter) {
        return !this.minaSokfilter$.value || !this.minaSokfilter$.value.some(x => x.namn.toLowerCase().trim() === filter.namn.toLowerCase().trim());
    }

    saveLimitReached() {
        return this.minaSokfilter$.value && this.minaSokfilter$.value.length >= this.maxSavedFilters;
    }

    saveSearchFilter(namedSearchFilter: IVKNamedSearchFilter) {
        this.webinstallningarService
            .setAsync(this.WIK, {
                minaFilter: [
                    ...this.minaSokfilter$.value,
                    ...[namedSearchFilter]
                ]
            })
            .then((result) => {
                this.getInstallningar();
            });
    }

    updateSearchFilterByNamn(namedSearchFilter: IVKNamedSearchFilter) {
        remove(this.minaSokfilter$.value, f => this.isEqualIgnoreCaseAndWhitespace(f.namn, namedSearchFilter.namn));
        this.saveSearchFilter(namedSearchFilter);
    }

    deleteSearchFilterByNamn(namn: string) {
        remove(this.minaSokfilter$.value, f => this.isEqualIgnoreCaseAndWhitespace(f.namn, namn));

        this.webinstallningarService
            .setAsync(this.WIK, {
                minaFilter: this.minaSokfilter$.value
            })
            .then((result) => {
                this.getInstallningar();
            });
    }

    private isEqualIgnoreCaseAndWhitespace(a: string, b: string): boolean {
        return a.trim().toLowerCase() === b.trim().toLowerCase();
    }
}
